namespace RedBullMOBILE360.ESim {
    export interface EsimActivationCodeRow {
        Id?: number;
        Iccid?: string;
        CreationDate?: string;
        ActivationCode?: string;
        Pin?: string;
        Puk?: string;
    }

    export namespace EsimActivationCodeRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Iccid';
        export const localTextPrefix = 'ESim.EsimActivationCode';
        export const deletePermission = 'ESim:EsimActivationCode';
        export const insertPermission = 'ESim:EsimActivationCode';
        export const readPermission = 'ESim:EsimActivationCode';
        export const updatePermission = 'ESim:EsimActivationCode';

        export declare const enum Fields {
            Id = "Id",
            Iccid = "Iccid",
            CreationDate = "CreationDate",
            ActivationCode = "ActivationCode",
            Pin = "Pin",
            Puk = "Puk"
        }
    }
}
